import axios from 'axios';
import get from 'lodash/get';

// Libs
import { thunkHandler, thunkErrorHanlder, parseUrl, Consequence } from '../../libs/utils';
import { email as emailCatalog, sms as smsCatalog } from '../../libs/statusCatalog';

// Constants
import { EMAIL_SETTINGS_BASE, EMAIL_SETTINGS_BY_ID, SMS_SETTINGS_BASE, SMS_SETTINGS_BY_ID, WHATSAPP_SETTINGS_BY_ID, WP_SETTINGS_BASE } from '../../constants/endpoints';

export const NEW_TEMPLATES                    = 'NEW_TEMPLATES';
export const NEW_DUE_DATE_TEMPLATE            = 'NEW_DUE_DATE_TEMPLATE';
export const NEW_EARLY_REMINDER_TEMPLATE      = 'NEW_EARLY_REMINDER_TEMPLATE';
export const NEW_LATE_PAYMENT_TEMPLATE        = 'NEW_LATE_PAYMENT_TEMPLATE';
export const NEW_RECEIPT_TEMPLATE             = 'NEW_RECEIPT_TEMPLATE';
export const NEW_SEND_INVOICE_TEMPLATE        = 'NEW_SEND_INVOICE_TEMPLATE';
export const NEW_ACCOUNT_STATEMENT_TEMPLATE   = 'NEW_ACCOUNT_STATEMENT_TEMPLATE';
export const NEW_SMS_TEMPLATES                = 'NEW_SMS_TEMPLATES';
export const NEW_DUE_DATE_TEMPLATE_SMS        = 'NEW_DUE_DATE_TEMPLATE_SMS';
export const NEW_EARLY_REMINDER_TEMPLATE_SMS  = 'NEW_EARLY_REMINDER_TEMPLATE_SMS';
export const NEW_LATE_PAYMENT_TEMPLATE_SMS    = 'NEW_LATE_PAYMENT_TEMPLATE_SMS';
export const NEW_RECEIPT_TEMPLATE_SMS         = 'NEW_RECEIPT_TEMPLATE_SMS';
export const NEW_SEND_INVOICE_TEMPLATE_SMS     = 'NEW_SEND_INVOICE_TEMPLATE_SMS';
export const NEW_ACCOUNT_STATEMENT_TEMPLATE_SMS = 'NEW_ACCOUNT_STATEMENT_TEMPLATE_SMS';
export const NEW_EMISSION_INVOICE_TEMPLATE_SMS = 'NEW_EMISSION_INVOICE_TEMPLATE_SMS';
export const NEW_PAYMENT_RECEIPT_TEMPLATE = 'NEW_PAYMENT_RECEIPT_TEMPLATE';

export const SUBMIT_LOADING                   = 'SUBMIT_LOADING';



export function getTemplateById(templateId) {
  return dispatch => axios.get(parseUrl(EMAIL_SETTINGS_BY_ID, { templateId }))
    .then(response => {
      const
        { action } = emailCatalog.getTemplate(templateId),
          data     = get(response, 'data.data');

      return thunkHandler(dispatch, data, action, 'ERROR');

    })
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getTemplateById


export function updateTemplateById(templateId, body) {
  return dispatch => axios.put(parseUrl(EMAIL_SETTINGS_BY_ID, { templateId }), body)
    .then(res => new Consequence({ dispatch,
        payload: { data: get(res, 'data.data') },
        eventTypes: { success: emailCatalog.getTemplate(templateId).action, error: 'ERROR' }

    })) // END if
    // .then(() => getTemplates());

} // END updateTemplateById

export function onChangeIsLoadingButton(value) {
  return dispatch => Promise.resolve(dispatch({
    type: SUBMIT_LOADING,
    payload: { isLoadingButton: value }

  }));

} // onChangeIsLoadingButton

export function getTemplates() {
  function parseTemplates(response, dispatch){
    const templates = get(response, 'data.data');
    dispatch({ type: NEW_TEMPLATES, payload: templates });

    if (Array.isArray(templates)) templates.forEach(template => {
      const id = get(template, 'template_type_id');
      switch(id){
        case 1:
          dispatch({ type: NEW_DUE_DATE_TEMPLATE, payload: template })
          break;

        case 2:
          dispatch({ type: NEW_LATE_PAYMENT_TEMPLATE, payload: template })
          break;

        case 3:
          dispatch({ type: NEW_RECEIPT_TEMPLATE, payload: template })
          break;

        case 4:
          dispatch({ type: NEW_EARLY_REMINDER_TEMPLATE, payload: template })
          break;

        case 5:
          dispatch({ type: NEW_SEND_INVOICE_TEMPLATE, payload: template })
          break;

        case 6:
          dispatch({ type: NEW_ACCOUNT_STATEMENT_TEMPLATE, payload: template })
          break;
        
        case 7:
          dispatch({ type: NEW_PAYMENT_RECEIPT_TEMPLATE, payload: template })
          break;

        default:
          break;

      } // END switch

    }); // END forEach

    return templates;

  } // END parseTemplates

  return dispatch => axios.get(EMAIL_SETTINGS_BASE)
    .then(response => parseTemplates(response, dispatch))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getTemplates

export function getTemplatesSms(type) {
  function parseTemplates(response, dispatch){
    const templates = get(response, 'data.data');
    dispatch({ type: NEW_SMS_TEMPLATES, payload: templates });

    if (Array.isArray(templates)) templates.forEach(template => {
      const id = get(template, 'template_type_id');
      switch(id){
        case 1:
          dispatch({ type: NEW_DUE_DATE_TEMPLATE_SMS, payload: template })
          break;

        case 2:
          dispatch({ type: NEW_LATE_PAYMENT_TEMPLATE_SMS, payload: template })
          break;

        case 3:
          dispatch({ type: NEW_RECEIPT_TEMPLATE_SMS, payload: template })
          break;

        case 4:
          dispatch({ type: NEW_EARLY_REMINDER_TEMPLATE_SMS, payload: template })
          break;

        case 5:
          dispatch({ type: NEW_SEND_INVOICE_TEMPLATE_SMS, payload: template })
          break;

        case 6:
          dispatch({ type: NEW_ACCOUNT_STATEMENT_TEMPLATE_SMS, payload: template })
          break;

        case 7:
          dispatch({ type: NEW_SEND_INVOICE_TEMPLATE_SMS, payload: template })
          break;

        default:
          break;

      } // END switch

    }); // END forEach

    return templates;

  } // END parseTemplates

  const endpoint = Number(type) === 2 ? SMS_SETTINGS_BASE : WP_SETTINGS_BASE;

  return dispatch => axios.get(endpoint)
    .then(response => parseTemplates(response, dispatch))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getTemplates


export function getSmsTemplateById(templateId) {
  return dispatch => axios.get(parseUrl(SMS_SETTINGS_BY_ID, { templateId }))
    .then(response => {
      const
        { action } = smsCatalog.getTemplate(templateId),
          data     = get(response, 'data.data');

      return thunkHandler(dispatch, data, action, 'ERROR');

    })
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getTemplateById

export function getWhatsAppTemplateById(templateId) {
  return dispatch => axios.get(parseUrl(WHATSAPP_SETTINGS_BY_ID, { templateId }))
    .then(response => {
      const
        { action } = smsCatalog.getTemplate(templateId),
          data     = get(response, 'data.data');

      return thunkHandler(dispatch, data, action, 'ERROR');

    })
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getTemplateById



// WEBPACK FOOTER //
// ./src/redux/actions/templateActions.js